import React, { useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import { translate } from '../../../base/i18n/functions';
const useStyles = makeStyles()(theme => {
    return {
        itemContainer: {
            display: 'flex',
            color: '#000000',
            alignItems: 'center',
            fontSize: '0.875rem',
            cursor: 'pointer',
            padding: theme.spacing(1.5, 2),
            borderBottom: `1px solid ${theme.palette.ui09 || '#E0E0E0'}`,
            transition: 'background-color 0.2s ease, color 0.2s ease',
            '&:hover': {
                backgroundColor: theme.palette.iisightHeader || theme.palette.action01,
                color: '#FFFFFF'
            }
        },
        activeItemContainer: {
            fontWeight: 600,
            backgroundColor: theme.palette.iisightHeader || theme.palette.action01,
            color: '#FFFFFF',
            '&:hover': {
                backgroundColor: theme.palette.iisightBrand700 || theme.palette.action01Hover,
                color: '#FFFFFF'
            }
        }
    };
});
/**
 * Component that renders the language list item.
 *
 * @returns {React$Element<any>}
 */
const LanguageListItem = ({ t, lang, selected, onLanguageSelected }) => {
    const { classes: styles } = useStyles();
    const onLanguageSelectedWrapper = useCallback(() => onLanguageSelected(lang), [lang]);
    return (React.createElement("div", { className: `${styles.itemContainer} ${selected ? styles.activeItemContainer : ''}`, onClick: onLanguageSelectedWrapper }, t(lang)));
};
export default translate(LanguageListItem);
